import {MeshCellImageValueFormat} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ImageValueFormat';
import {MeshCellMaskedTextValueFormat} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/MaskedTextValueFormat';
import {
    IMeshCellValueFormat,
    ValueFormat
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ValueFormat';
import {MeshCellValueFormatKind} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellFormat/valueFormat/ValueFormatKind';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import * as moment from 'moment';

const percentValueExtractor = value =>
{
    const numberPart = RegExp(/-?[\d,]*\.?\d*/)
        .exec(value.trim())[0];
    if( !numberPart )
    {
        return new AString(value);
    }
    let withoutDelimiters = numberPart.replace(/,/gm, '');
    if( withoutDelimiters.startsWith('.') )
    {
        withoutDelimiters = '0' + withoutDelimiters;
    }
    let number = Number.parseFloat(withoutDelimiters) / 100;
    return new ANumber(number);
};

const percentFormatChecker = value =>
{
    return RegExp(/^-?[\d,]*\.?\d*%$/).test(value);
};

const currencyFormatChecker = value =>
{
    return RegExp(/^-?[\$][\d,]*\.?\d*$/).test(value) || RegExp(/^[\$]\([\d,]*\.?\d*\)$/).test(value);
};

const currencyValueExtractor = value =>
{
    const withoutCurrency = value.replace('$', '').trim();
    const numberPart = RegExp(/-?[\d,.]+\.?\d*/)
        .exec(withoutCurrency);
    if( !numberPart )
    {
        return new AString(value);
    }
    let withoutDelimiters = numberPart[0].replace(/,/gm, '');
    if( withoutDelimiters.startsWith('.') )
    {
        withoutDelimiters = '0' + withoutDelimiters;
    }
    if( value.indexOf(')') > -1 && value.indexOf('(') > -1 )
    {
        return new ANumber(Number.parseFloat(withoutDelimiters) * -1);
    }
    else
    {
        return new ANumber(Number.parseFloat(withoutDelimiters));
    }
};

const dateFormats = ['MM/DD/YYYY', 'MM/DD/YY', 'M/D/YY', 'M/DD/YY', 'MM/D/YY', 'M/D/YYYY', 'YYYY-MM-DD', 'YYYY.MM.DD', 'YYYY/MM/DD',
    'DD.MM.YYYY', 'DD/MM/YYYY', 'DD-MM-YYYY', 'MM-DD-YYYY', 'DD.MM.YY', 'DD/MM/YY', 'DD-MM-YY', 'MM-DD-YY', 'D.MM.YYYY',
    'D/MM/YYYY', 'D-MM-YYYY', 'MM-D-YYYY', 'MM/D/YYYY', 'D.MM.YY', 'D/MM/YY', 'D-MM-YY', 'MM-D-YY', 'DD.M.YYYY', 'DD/M/YYYY',
    'DD-M-YYYY', 'M-DD-YYYY', 'M/DD/YYYY', 'DD.M.YY', 'DD/M/YY', 'DD-M-YY', 'M-DD-YY', 'D.M.YYYY', 'D/M/YYYY', 'D-M-YYYY',
    'M-D-YYYY', 'D.M.YY', 'D/M/YY', 'D-M-YY', 'M-D-YY'];

const dateTimeFormats = ['MM/DD/YYYY LT', 'MM/DD/YYYY HH:mm:ss', 'MM/DD/YYYY HH:mm', 'MM/DD/YYYY hh:mm',
    'MM/DD/YYYY hh:mm:ss', 'MM/DD/YYYY H:mm', 'MM/DD/YYYY h:mm', 'MM/DD/YYYY ha', 'MM/DD/YYYY hA',
    'MM/DD/YYYY h:ma', 'MM/DD/YYYY h:mA', 'MM/DD/YYYY h a', 'MM/DD/YYYY h:m a', 'MM/DD/YY LT', 'MM/DD/YY HH:mm:ss',
    'MM/DD/YY HH:mm', 'MM/DD/YY hh:mm', 'MM/DD/YY hh:mm:ss', 'MM/DD/YY H:mm', 'MM/DD/YY h:mm', 'MM/DD/YY ha', 'MM/DD/YY hA',
    'MM/DD/YY h:ma', 'MM/DD/YY h:mA', 'MM/DD/YY h a', 'MM/DD/YY h:m a', 'M/DD/YYYY LT', 'M/DD/YYYY HH:mm:ss', 'M/DD/YYYY HH:mm',
    'M/DD/YYYY hh:mm', 'M/DD/YYYY hh:mm:ss', 'M/DD/YYYY H:mm', 'M/DD/YYYY h:mm', 'M/DD/YYYY ha', 'M/DD/YYYY hA',
    'M/DD/YYYY h:ma', 'M/DD/YYYY h:mA', 'M/DD/YYYY h a', 'M/DD/YYYY h:m a', 'MM/D/YYYY LT', 'MM/D/YYYY HH:mm:ss',
    'MM/D/YYYY HH:mm', 'MM/D/YYYY hh:mm', 'MM/D/YYYY hh:mm:ss', 'MM/D/YYYY H:mm', 'MM/D/YYYY h:mm',
    'MM/D/YYYY ha', 'MM/D/YYYY hA', 'MM/D/YYYY h:ma', 'MM/D/YYYY h:mA', 'MM/D/YYYY h a', 'MM/D/YYYY h:m a', 'YYYY-MM-DD LT',
    'M/D/YY LT', 'M/D/YY HH:mm:ss', 'M/D/YY HH:mm',
    'M/D/YY hh:mm', 'M/D/YY hh:mm:ss', 'M/D/YY H:mm', 'M/D/YY h:mm', 'M/D/YY ha', 'M/D/YY hA', 'M/D/YY h:ma',
    'M/D/YY h:mA', 'M/D/YY h a', 'M/D/YY h:m a', 'M/DD/YY LT', 'M/DD/YY HH:mm:ss', 'M/DD/YY HH:mm', 'M/DD/YY hh:mm',
    'M/DD/YY hh:mm:ss', 'M/DD/YY H:mm', 'M/DD/YY h:mm', 'M/DD/YY ha', 'M/DD/YY hA', 'M/DD/YY h:ma', 'M/DD/YY h:mA',
    'M/DD/YY h a', 'M/DD/YY h:m a', 'MM/D/YY LT', 'MM/D/YY HH:mm:ss', 'MM/D/YY HH:mm', 'MM/D/YY hh:mm',
    'MM/D/YY hh:mm:ss', 'MM/D/YY H:mm', 'MM/D/YY h:mm', 'MM/D/YY ha', 'MM/D/YY hA', 'MM/D/YY h:ma', 'MM/D/YY h:mA',
    'MM/D/YY h a', 'MM/D/YY h:m a', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD hh:mm', 'YYYY-MM-DD hh:mm:ss',
    'YYYY-MM-DD H:mm', 'YYYY-MM-DD h:mm', 'YYYY-MM-DD ha', 'YYYY-MM-DD hA', 'YYYY-MM-DD h:ma', 'YYYY-MM-DD h:mA',
    'YYYY-MM-DD h a', 'YYYY-MM-DD h:m a', 'YYYY.MM.DD LT', 'YYYY.MM.DD HH:mm:ss', 'YYYY.MM.DD HH:mm',
    'YYYY.MM.DD hh:mm', 'YYYY.MM.DD hh:mm:ss', 'YYYY.MM.DD H:mm', 'YYYY.MM.DD h:mm', 'YYYY.MM.DD ha',
    'YYYY.MM.DD hA', 'YYYY.MM.DD h:ma', 'YYYY.MM.DD h:mA', 'YYYY.MM.DD h a', 'YYYY.MM.DD h:m a',
    'YYYY/MM/DD LT', 'YYYY/MM/DD HH:mm:ss', 'YYYY/MM/DD HH:mm', 'YYYY/MM/DD hh:mm', 'YYYY/MM/DD hh:mm:ss',
    'YYYY/MM/DD H:mm', 'YYYY/MM/DD h:mm', 'YYYY/MM/DD ha', 'YYYY/MM/DD hA', 'YYYY/MM/DD h:ma', 'YYYY/MM/DD h:mA',
    'YYYY/MM/DD h a', 'YYYY/MM/DD h:m a', 'DD.MM.YYYY LT', 'DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY HH:mm', 'DD.MM.YYYY hh:mm',
    'DD.MM.YYYY hh:mm:ss', 'DD.MM.YYYY H:mm', 'DD.MM.YYYY h:mm', 'DD.MM.YYYY ha', 'DD.MM.YYYY hA', 'DD.MM.YYYY h:ma',
    'DD.MM.YYYY h:mA', 'DD.MM.YYYY h a', 'DD.MM.YYYY h:m a', 'DD/MM/YYYY LT', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm',
    'DD/MM/YYYY hh:mm', 'DD/MM/YYYY hh:mm:ss', 'DD/MM/YYYY H:mm', 'DD/MM/YYYY h:mm', 'DD/MM/YYYY ha', 'DD/MM/YYYY hA',
    'DD/MM/YYYY h:ma', 'DD/MM/YYYY h:mA', 'DD/MM/YYYY h a', 'DD/MM/YYYY h:m a', 'DD-MM-YYYY LT', 'DD-MM-YYYY HH:mm:ss',
    'DD-MM-YYYY HH:mm', 'DD-MM-YYYY hh:mm', 'DD-MM-YYYY hh:mm:ss', 'DD-MM-YYYY H:mm', 'DD-MM-YYYY h:mm', 'DD-MM-YYYY ha',
    'DD-MM-YYYY hA', 'DD-MM-YYYY h:ma', 'DD-MM-YYYY h:mA', 'DD-MM-YYYY h a', 'DD-MM-YYYY h:m a', 'MM-DD-YYYY LT',
    'MM-DD-YYYY HH:mm:ss', 'MM-DD-YYYY HH:mm', 'MM-DD-YYYY hh:mm', 'MM-DD-YYYY hh:mm:ss', 'MM-DD-YYYY H:mm',
    'MM-DD-YYYY h:mm', 'MM-DD-YYYY ha', 'MM-DD-YYYY hA', 'MM-DD-YYYY h:ma', 'MM-DD-YYYY h:mA', 'MM-DD-YYYY h a',
    'MM-DD-YYYY h:m a', 'DD.MM.YY LT', 'DD.MM.YY HH:mm:ss',
    'DD.MM.YY HH:mm', 'DD.MM.YY hh:mm', 'DD.MM.YY hh:mm:ss', 'DD.MM.YY H:mm', 'DD.MM.YY h:mm', 'DD.MM.YY ha',
    'DD.MM.YY hA', 'DD.MM.YY h:ma', 'DD.MM.YY h:mA', 'DD.MM.YY h a', 'DD.MM.YY h:m a', 'DD/MM/YY LT',
    'DD/MM/YY HH:mm:ss', 'DD/MM/YY HH:mm', 'DD/MM/YY hh:mm', 'DD/MM/YY hh:mm:ss', 'DD/MM/YY H:mm', 'DD/MM/YY h:mm',
    'DD/MM/YY ha', 'DD/MM/YY hA', 'DD/MM/YY h:ma', 'DD/MM/YY h:mA', 'DD/MM/YY h a', 'DD/MM/YY h:m a', 'DD-MM-YY LT',
    'DD-MM-YY HH:mm:ss', 'DD-MM-YY HH:mm', 'DD-MM-YY hh:mm', 'DD-MM-YY hh:mm:ss', 'DD-MM-YY H:mm', 'DD-MM-YY h:mm',
    'DD-MM-YY ha', 'DD-MM-YY hA', 'DD-MM-YY h:ma', 'DD-MM-YY h:mA', 'DD-MM-YY h a', 'DD-MM-YY h:m a', 'MM-DD-YY LT',
    'MM-DD-YY HH:mm:ss', 'MM-DD-YY HH:mm', 'MM-DD-YY hh:mm', 'MM-DD-YY hh:mm:ss', 'MM-DD-YY H:mm', 'MM-DD-YY h:mm',
    'MM-DD-YY ha', 'MM-DD-YY hA', 'MM-DD-YY h:ma', 'MM-DD-YY h:mA', 'MM-DD-YY h a', 'MM-DD-YY h:m a', 'D.MM.YYYY LT',
    'D.MM.YYYY HH:mm:ss', 'D.MM.YYYY HH:mm', 'D.MM.YYYY hh:mm', 'D.MM.YYYY hh:mm:ss', 'D.MM.YYYY H:mm', 'D.MM.YYYY h:mm',
    'D.MM.YYYY ha', 'D.MM.YYYY hA', 'D.MM.YYYY h:ma', 'D.MM.YYYY h:mA', 'D.MM.YYYY h a', 'D.MM.YYYY h:m a',
    'D/MM/YYYY LT', 'D/MM/YYYY HH:mm:ss', 'D/MM/YYYY HH:mm', 'D/MM/YYYY hh:mm', 'D/MM/YYYY hh:mm:ss', 'D/MM/YYYY H:mm',
    'D/MM/YYYY h:mm', 'D/MM/YYYY ha', 'D/MM/YYYY hA', 'D/MM/YYYY h:ma', 'D/MM/YYYY h:mA', 'D/MM/YYYY h a',
    'D/MM/YYYY h:m a', 'D-MM-YYYY LT', 'D-MM-YYYY HH:mm:ss', 'D-MM-YYYY HH:mm', 'D-MM-YYYY hh:mm', 'D-MM-YYYY hh:mm:ss',
    'D-MM-YYYY H:mm', 'D-MM-YYYY h:mm', 'D-MM-YYYY ha', 'D-MM-YYYY hA', 'D-MM-YYYY h:ma', 'D-MM-YYYY h:mA',
    'D-MM-YYYY h a', 'D-MM-YYYY h:m a', 'MM-D-YYYY LT', 'MM-D-YYYY HH:mm:ss', 'MM-D-YYYY HH:mm', 'MM-D-YYYY hh:mm',
    'MM-D-YYYY hh:mm:ss', 'MM-D-YYYY H:mm', 'MM-D-YYYY h:mm', 'MM-D-YYYY ha', 'MM-D-YYYY hA', 'MM-D-YYYY h:ma',
    'MM-D-YYYY h:mA', 'MM-D-YYYY h a', 'MM-D-YYYY h:m a', 'D.MM.YY LT', 'D.MM.YY HH:mm:ss', 'D.MM.YY HH:mm',
    'D.MM.YY hh:mm', 'D.MM.YY hh:mm:ss', 'D.MM.YY H:mm', 'D.MM.YY h:mm', 'D.MM.YY ha', 'D.MM.YY hA', 'D.MM.YY h:ma',
    'D.MM.YY h:mA', 'D.MM.YY h a', 'D.MM.YY h:m a',
    'D/MM/YY LT', 'D/MM/YY HH:mm:ss', 'D/MM/YY HH:mm', 'D/MM/YY hh:mm', 'D/MM/YY hh:mm:ss', 'D/MM/YY H:mm',
    'D/MM/YY h:mm', 'D/MM/YY ha', 'D/MM/YY hA', 'D/MM/YY h:ma', 'D/MM/YY h:mA', 'D/MM/YY h a', 'D/MM/YY h:m a',
    'D-MM-YY LT', 'D-MM-YY HH:mm:ss', 'D-MM-YY HH:mm', 'D-MM-YY hh:mm', 'D-MM-YY hh:mm:ss', 'D-MM-YY H:mm',
    'D-MM-YY h:mm', 'D-MM-YY ha', 'D-MM-YY hA', 'D-MM-YY h:ma', 'D-MM-YY h:mA', 'D-MM-YY h a', 'D-MM-YY h:m a',
    'MM-D-YY LT', 'MM-D-YY HH:mm:ss', 'MM-D-YY HH:mm', 'MM-D-YY hh:mm', 'MM-D-YY hh:mm:ss', 'MM-D-YY H:mm',
    'MM-D-YY h:mm', 'MM-D-YY ha', 'MM-D-YY hA', 'MM-D-YY h:ma', 'MM-D-YY h:mA', 'MM-D-YY h a', 'MM-D-YY h:m a',
    'DD.M.YYYY LT', 'DD.M.YYYY HH:mm:ss', 'DD.M.YYYY HH:mm', 'DD.M.YYYY hh:mm', 'DD.M.YYYY hh:mm:ss',
    'DD.M.YYYY H:mm', 'DD.M.YYYY h:mm', 'DD.M.YYYY ha', 'DD.M.YYYY hA', 'DD.M.YYYY h:ma', 'DD.M.YYYY h:mA',
    'DD.M.YYYY h a', 'DD.M.YYYY h:m a', 'DD/M/YYYY LT', 'DD/M/YYYY HH:mm:ss', 'DD/M/YYYY HH:mm',
    'DD/M/YYYY hh:mm', 'DD/M/YYYY hh:mm:ss', 'DD/M/YYYY H:mm', 'DD/M/YYYY h:mm', 'DD/M/YYYY ha',
    'DD/M/YYYY hA', 'DD/M/YYYY h:ma', 'DD/M/YYYY h:mA', 'DD/M/YYYY h a', 'DD/M/YYYY h:m a', 'DD-M-YYYY LT',
    'DD-M-YYYY HH:mm:ss', 'DD-M-YYYY HH:mm', 'DD-M-YYYY hh:mm', 'DD-M-YYYY hh:mm:ss', 'DD-M-YYYY H:mm',
    'DD-M-YYYY h:mm', 'DD-M-YYYY ha', 'DD-M-YYYY hA', 'DD-M-YYYY h:ma', 'DD-M-YYYY h:mA', 'DD-M-YYYY h a',
    'DD-M-YYYY h:m a', 'M-DD-YYYY LT', 'M-DD-YYYY HH:mm:ss', 'M-DD-YYYY HH:mm', 'M-DD-YYYY hh:mm',
    'M-DD-YYYY hh:mm:ss', 'M-DD-YYYY H:mm', 'M-DD-YYYY h:mm', 'M-DD-YYYY ha', 'M-DD-YYYY hA', 'M-DD-YYYY h:ma',
    'M-DD-YYYY h:mA', 'M-DD-YYYY h a', 'M-DD-YYYY h:m a', 'DD.M.YY LT', 'DD.M.YY HH:mm:ss',
    'DD.M.YY HH:mm', 'DD.M.YY hh:mm', 'DD.M.YY hh:mm:ss', 'DD.M.YY H:mm', 'DD.M.YY h:mm', 'DD.M.YY ha',
    'DD.M.YY hA', 'DD.M.YY h:ma', 'DD.M.YY h:mA', 'DD.M.YY h a', 'DD.M.YY h:m a', 'DD/M/YY LT',
    'DD/M/YY HH:mm:ss', 'DD/M/YY HH:mm', 'DD/M/YY hh:mm', 'DD/M/YY hh:mm:ss', 'DD/M/YY H:mm',
    'DD/M/YY h:mm', 'DD/M/YY ha', 'DD/M/YY hA', 'DD/M/YY h:ma', 'DD/M/YY h:mA', 'DD/M/YY h a',
    'DD/M/YY h:m a', 'DD-M-YY LT', 'DD-M-YY HH:mm:ss', 'DD-M-YY HH:mm', 'DD-M-YY hh:mm', 'DD-M-YY hh:mm:ss',
    'DD-M-YY H:mm', 'DD-M-YY h:mm', 'DD-M-YY ha', 'DD-M-YY hA', 'DD-M-YY h:ma', 'DD-M-YY h:mA', 'DD-M-YY h a',
    'DD-M-YY h:m a', 'M-DD-YY LT', 'M-DD-YY HH:mm:ss', 'M-DD-YY HH:mm', 'M-DD-YY hh:mm', 'M-DD-YY hh:mm:ss',
    'M-DD-YY H:mm', 'M-DD-YY h:mm', 'M-DD-YY ha', 'M-DD-YY hA', 'M-DD-YY h:ma', 'M-DD-YY h:mA', 'M-DD-YY h a',
    'M-DD-YY h:m a', 'D.M.YYYY LT', 'D.M.YYYY HH:mm:ss', 'D.M.YYYY HH:mm', 'D.M.YYYY hh:mm', 'D.M.YYYY hh:mm:ss',
    'D.M.YYYY H:mm', 'D.M.YYYY h:mm', 'D.M.YYYY ha', 'D.M.YYYY hA', 'D.M.YYYY h:ma', 'D.M.YYYY h:mA',
    'D.M.YYYY h a', 'D.M.YYYY h:m a', 'D/M/YYYY LT', 'D/M/YYYY HH:mm:ss', 'D/M/YYYY HH:mm', 'D/M/YYYY hh:mm',
    'D/M/YYYY hh:mm:ss', 'D/M/YYYY H:mm', 'D/M/YYYY h:mm', 'D/M/YYYY ha', 'D/M/YYYY hA', 'D/M/YYYY h:ma',
    'D/M/YYYY h:mA', 'D/M/YYYY h a', 'D/M/YYYY h:m a', 'D-M-YYYY LT', 'D-M-YYYY HH:mm:ss', 'D-M-YYYY HH:mm',
    'D-M-YYYY hh:mm', 'D-M-YYYY hh:mm:ss', 'D-M-YYYY H:mm', 'D-M-YYYY h:mm', 'D-M-YYYY ha', 'D-M-YYYY hA',
    'D-M-YYYY h:ma', 'D-M-YYYY h:mA', 'D-M-YYYY h a', 'D-M-YYYY h:m a', 'M-D-YYYY LT', 'M-D-YYYY HH:mm:ss',
    'M-D-YYYY HH:mm', 'M-D-YYYY hh:mm', 'M-D-YYYY hh:mm:ss', 'M-D-YYYY H:mm', 'M-D-YYYY h:mm', 'M-D-YYYY ha',
    'M-D-YYYY hA', 'M-D-YYYY h:ma', 'M-D-YYYY h:mA', 'M-D-YYYY h a', 'M-D-YYYY h:m a', 'M/D/YYYY LT',
    'M/D/YYYY HH:mm:ss', 'M/D/YYYY HH:mm', 'M/D/YYYY hh:mm', 'M/D/YYYY hh:mm:ss', 'M/D/YYYY H:mm', 'M/D/YYYY h:mm',
    'M/D/YYYY ha', 'M/D/YYYY hA', 'M/D/YYYY h:ma', 'M/D/YYYY h:mA', 'M/D/YYYY h a', 'M/D/YYYY h:m a',
    'D.M.YY LT', 'D.M.YY HH:mm:ss', 'D.M.YY HH:mm', 'D.M.YY hh:mm', 'D.M.YY hh:mm:ss', 'D.M.YY H:mm', 'D.M.YY h:mm',
    'D.M.YY ha', 'D.M.YY hA', 'D.M.YY h:ma', 'D.M.YY h:mA', 'D.M.YY h a', 'D.M.YY h:m a', 'D/M/YY LT', 'D/M/YY HH:mm:ss',
    'D/M/YY HH:mm', 'D/M/YY hh:mm', 'D/M/YY hh:mm:ss', 'D/M/YY H:mm', 'D/M/YY h:mm', 'D/M/YY ha', 'D/M/YY hA',
    'D/M/YY h:ma', 'D/M/YY h:mA', 'D/M/YY h a', 'D/M/YY h:m a', 'D-M-YY LT', 'D-M-YY HH:mm:ss', 'D-M-YY HH:mm',
    'D-M-YY hh:mm', 'D-M-YY hh:mm:ss', 'D-M-YY H:mm', 'D-M-YY h:mm', 'D-M-YY ha', 'D-M-YY hA', 'D-M-YY h:ma',
    'D-M-YY h:mA', 'D-M-YY h a', 'D-M-YY h:m a', 'M-D-YY LT', 'M-D-YY HH:mm:ss', 'M-D-YY HH:mm', 'M-D-YY hh:mm',
    'M-D-YY hh:mm:ss', 'M-D-YY H:mm', 'M-D-YY h:mm', 'M-D-YY ha', 'M-D-YY hA', 'M-D-YY h:ma', 'M-D-YY h:mA',
    'M-D-YY h a', 'M-D-YY h:m a'
];

/*
 * All build-in formats that are used within the system. Id's correspond to those that are given to Excel built-in
 * formats during import process
 * */
export class MeshCellValueFormat
{
    //Special cases
    public static readonly Image:IMeshCellValueFormat = new MeshCellImageValueFormat();
    public static readonly MaskedText:IMeshCellValueFormat = new MeshCellMaskedTextValueFormat(true);

    //Built-in formats to use from menu
    public static readonly General:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f1000',
        MeshCellValueFormatKind.General, 'General', val => true,
        val =>
        {
            if( val.toLowerCase() === 'true' || val.toLowerCase() === 'false' )
            {
                return ABoolean.fromString(val);
            }
            return new AString(val);
        });
    public static readonly PlainText:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f3900',
        MeshCellValueFormatKind.PlainText, '@', val => true, val => new AString(val));
    public static readonly Number:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f3000',
        MeshCellValueFormatKind.Number, '0.00',
        value =>
        {
            if( value === '.' || value === '-' ) return false;
            const isSimpleNumber = RegExp(/^-?\d*\.?\d*$/).test(value);
            const isNumberWithCommas = RegExp(/(^-?(\d+)(,\d{3,})+\.?\d*$)|(^-?(\d+)(,\d{3,},?)+\.?\d*$)/).test(value);
            return isSimpleNumber || isNumberWithCommas;
        });
    public static readonly Percent:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f1200',
        MeshCellValueFormatKind.Percent, '0.00%', percentFormatChecker, percentValueExtractor);
    public static readonly Accounting:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f6000',
        MeshCellValueFormatKind.Accounting, '"$"#,##0.00_);$(#,##0.00);_(* "$""-"_)', currencyFormatChecker, currencyValueExtractor);
    public static readonly Financial:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f3100',
        MeshCellValueFormatKind.Financial, '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)');
    public static readonly Currency:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f8000',
        MeshCellValueFormatKind.Currency, '"$"#,##0.00;-$#,##0.00', currencyFormatChecker, currencyValueExtractor);
    public static readonly CurrencyRounded:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f7000',
        MeshCellValueFormatKind.CurrencyRounded, '$#,##0;-$#,##0',
        value =>
        {
            return RegExp(/^[\$][\d,]*\.?\d*$/).test(value) || RegExp(/^[\$]\([\d,]*\.?\d*\)$/).test(value);
        }, currencyValueExtractor);
    public static readonly Date:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f1600',
        MeshCellValueFormatKind.Date, 'MM/DD/YYYY',
        value =>
        {
            return moment(value, dateFormats, true).isValid();
        }, value =>
        {
            let aMoment = moment.utc(value, dateFormats, true);
            const daysFrom = ADate._daysFrom1900(aMoment);
            if( daysFrom < 0 )
            {
                return new AString(value);
            }
            else
            {
                return new ANumber(daysFrom);
            }
        });
    public static readonly Time:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f2200',
        MeshCellValueFormatKind.Time, 'h:mm:ss AM/PM',
        value => ATime.isValid(value),
        value =>
        {
            const aTime:ATime | AError = ATime.fromString(value);

            if( Type.isInstanceOf(aTime, Type.Time) )
                return new ANumber((aTime as ATime).toExcelTime());

            return aTime as AError;
        });
    public static readonly DateTime:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f2500',
        MeshCellValueFormatKind.DateTime, 'MM/DD/YYYY hh:mm',
        value =>
        {
            return moment(value, dateTimeFormats, true).isValid();
        }, value =>
        {
            const date = moment(value, dateTimeFormats, true).toDate();
            const aDateTime = ADateTime.fromJSDate(date);
            const number = aDateTime.toExcelDate();
            if( number < 0 )
            {
                return new AString(value);
            }
            else
            {
                return new ANumber(number);
            }
        }
    );
    public static readonly Duration:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f3600',
        MeshCellValueFormatKind.Duration, '[h]:mm:ss.000',
        value =>
        {
            return RegExp(/^\d{0,2}:?\d{0,2}:?\d{1,2}.\d{0,3}$/).test(value);
        }, value =>
        {
            const duration = RegExp(/^\d{0,2}:?\d{0,2}:?\d{1,2}.\d{0,3}$/).exec(value.trim())[0];
            if( !duration )
            {
                return new AString(value);
            }
            const parts = duration.split(':');
            let hours = 0;
            let minutes = 0;
            let seconds = 0;
            if( parts.length == 1 )
            { //user entered just number, interpret it as days
                hours = Number.parseFloat(parts[0]) * 86400;
            }
            else
            {
                if( parts[0] )
                {
                    hours = Number.parseFloat(parts[0]) * 3600;
                }
                if( parts[1] )
                {
                    minutes = Number.parseFloat(parts[1]) * 60;
                }
                if( parts[2] )
                {
                    seconds = Number.parseFloat(parts[2]);
                }
            }
            return new ANumber((hours + minutes + seconds) / 86400);
        });
    public static readonly Timestamp:IMeshCellValueFormat = new ValueFormat('00000000-0000-0000-0000-de4db33f4100',
        MeshCellValueFormatKind.Timestamp, 'MM/DD/YYYY hh:mm:ss.000');

    //Map with all the rest of built-in formats
    public static readonly BuiltInFormats = {

        'Image': MeshCellValueFormat.Image,

        //First built-in formats from Excel. Include formats from properties above as they are actually taken from excel
        '00000000-0000-0000-0000-de4db33f1000': MeshCellValueFormat.General,
        '00000000-0000-0000-0000-de4db33f2000': new ValueFormat('00000000-0000-0000-0000-de4db33f2000', MeshCellValueFormatKind.Number, '0'),
        '00000000-0000-0000-0000-de4db33f3000': MeshCellValueFormat.Number,
        '00000000-0000-0000-0000-de4db33f4000': new ValueFormat('00000000-0000-0000-0000-de4db33f4000', MeshCellValueFormatKind.Number, '#,##0'),
        '00000000-0000-0000-0000-de4db33f5000': new ValueFormat('00000000-0000-0000-0000-de4db33f5000', MeshCellValueFormatKind.Number, '#,##0.00'),
        '00000000-0000-0000-0000-de4db33f7000': MeshCellValueFormat.CurrencyRounded,
        '00000000-0000-0000-0000-de4db33f9000': new ValueFormat('00000000-0000-0000-0000-de4db33f9000', MeshCellValueFormatKind.Accounting, '"$"#,##0.00_);[Red]("$"#,##0.00)'),
        '00000000-0000-0000-0000-de4db33f1100': new ValueFormat('00000000-0000-0000-0000-de4db33f1100', MeshCellValueFormatKind.Percent, '0%'),
        '00000000-0000-0000-0000-de4db33f1200': MeshCellValueFormat.Percent,
        '00000000-0000-0000-0000-de4db33f1300': new ValueFormat('00000000-0000-0000-0000-de4db33f1300', MeshCellValueFormatKind.Percent, '0.00E+00'),
        '00000000-0000-0000-0000-de4db33f1400': new ValueFormat('00000000-0000-0000-0000-de4db33f1400', MeshCellValueFormatKind.Fraction, '# ?/?'),
        '00000000-0000-0000-0000-de4db33f1500': new ValueFormat('00000000-0000-0000-0000-de4db33f1500', MeshCellValueFormatKind.Fraction, '# ??/??'),
        '00000000-0000-0000-0000-de4db33f1600': MeshCellValueFormat.Date,
        '00000000-0000-0000-0000-de4db33f1700': new ValueFormat('00000000-0000-0000-0000-de4db33f1700', MeshCellValueFormatKind.Date, 'd-mmm-yy'),
        '00000000-0000-0000-0000-de4db33f1800': new ValueFormat('00000000-0000-0000-0000-de4db33f1800', MeshCellValueFormatKind.Date, 'd-mmm'),
        '00000000-0000-0000-0000-de4db33f1900': new ValueFormat('00000000-0000-0000-0000-de4db33f1900', MeshCellValueFormatKind.Date, 'mmm-yy'),
        '00000000-0000-0000-0000-de4db33f2100': new ValueFormat('00000000-0000-0000-0000-de4db33f2100', MeshCellValueFormatKind.Time, 'h:mm AM/PM'),
        '00000000-0000-0000-0000-de4db33f2200': MeshCellValueFormat.Time,
        '00000000-0000-0000-0000-de4db33f2300': new ValueFormat('00000000-0000-0000-0000-de4db33f2300', MeshCellValueFormatKind.Time, 'h:mm'),
        '00000000-0000-0000-0000-de4db33f2400': new ValueFormat('00000000-0000-0000-0000-de4db33f2400', MeshCellValueFormatKind.Time, 'h:mm:ss'),
        '00000000-0000-0000-0000-de4db33f2500': MeshCellValueFormat.DateTime,
        '00000000-0000-0000-0000-de4db33f2501': new ValueFormat('00000000-0000-0000-0000-de4db33f2501',
            MeshCellValueFormatKind.DateTime, 'MM/DD/YYYY hh:mm:ss',
            value =>
            {
                return moment(value, dateTimeFormats, true).isValid();
            }, value =>
            {
                const date = moment(value, dateTimeFormats, true).toDate();
                const aDateTime = ADateTime.fromJSDate(date);
                const number = aDateTime.toExcelDate();
                return new ANumber(number);
            }
        ),
        '00000000-0000-0000-0000-de4db33f2600': new ValueFormat('00000000-0000-0000-0000-de4db33f2600', MeshCellValueFormatKind.Accounting, '#,##0_);(#,##0)'),
        '00000000-0000-0000-0000-de4db33f2700': new ValueFormat('00000000-0000-0000-0000-de4db33f2700', MeshCellValueFormatKind.Accounting, '#,##0_);[Red](#,##0)'),
        '00000000-0000-0000-0000-de4db33f2800': new ValueFormat('00000000-0000-0000-0000-de4db33f2800', MeshCellValueFormatKind.Accounting, '#,##0.00_);(#,##0.00)'),
        '00000000-0000-0000-0000-de4db33f2900': new ValueFormat('00000000-0000-0000-0000-de4db33f2900', MeshCellValueFormatKind.Accounting, '#,##0.00_);[Red](#,##0.00)'),
        '00000000-0000-0000-0000-de4db33f3200': new ValueFormat('00000000-0000-0000-0000-de4db33f3200', MeshCellValueFormatKind.Accounting, '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3300': new ValueFormat('00000000-0000-0000-0000-de4db33f3300', MeshCellValueFormatKind.Accounting, '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3400': new ValueFormat('00000000-0000-0000-0000-de4db33f3400', MeshCellValueFormatKind.Accounting, '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3500': new ValueFormat('00000000-0000-0000-0000-de4db33f3500', MeshCellValueFormatKind.Duration, 'mm:ss'),
        '00000000-0000-0000-0000-de4db33f3600': MeshCellValueFormat.Duration,
        '00000000-0000-0000-0000-de4db33f3700': new ValueFormat('00000000-0000-0000-0000-de4db33f3700', MeshCellValueFormatKind.Duration, 'mm:ss.0'),
        '00000000-0000-0000-0000-de4db33f3800': new ValueFormat('00000000-0000-0000-0000-de4db33f3800', MeshCellValueFormatKind.Fraction, '##0.0E+0'),
        '00000000-0000-0000-0000-de4db33f3900': MeshCellValueFormat.PlainText,
        '00000000-0000-0000-0000-de4db33f4100': MeshCellValueFormat.Timestamp,
        //Hack for numeric formats with various digits after point. Created 10 formats for digits after point from 0 to ten
        //in order to simply switch them instead of creating new each time user adjusts amount of digits.
        '00000000-0000-0000-0000-de4db33f2001': new ValueFormat('00000000-0000-0000-0000-de4db33f2001', MeshCellValueFormatKind.Number, '0.0'),
        '00000000-0000-0000-0000-de4db33f2002': new ValueFormat('00000000-0000-0000-0000-de4db33f2002', MeshCellValueFormatKind.Number, '0.00'),
        '00000000-0000-0000-0000-de4db33f2003': new ValueFormat('00000000-0000-0000-0000-de4db33f2003', MeshCellValueFormatKind.Number, '0.000'),
        '00000000-0000-0000-0000-de4db33f2004': new ValueFormat('00000000-0000-0000-0000-de4db33f2004', MeshCellValueFormatKind.Number, '0.0000'),
        '00000000-0000-0000-0000-de4db33f2005': new ValueFormat('00000000-0000-0000-0000-de4db33f2005', MeshCellValueFormatKind.Number, '0.00000'),
        '00000000-0000-0000-0000-de4db33f2006': new ValueFormat('00000000-0000-0000-0000-de4db33f2006', MeshCellValueFormatKind.Number, '0.000000'),
        '00000000-0000-0000-0000-de4db33f2007': new ValueFormat('00000000-0000-0000-0000-de4db33f2007', MeshCellValueFormatKind.Number, '0.0000000'),
        '00000000-0000-0000-0000-de4db33f2008': new ValueFormat('00000000-0000-0000-0000-de4db33f2008', MeshCellValueFormatKind.Number, '0.00000000'),
        '00000000-0000-0000-0000-de4db33f2009': new ValueFormat('00000000-0000-0000-0000-de4db33f2009', MeshCellValueFormatKind.Number, '0.000000000'),
        '00000000-0000-0000-0000-de4db33f2010': new ValueFormat('00000000-0000-0000-0000-de4db33f2010', MeshCellValueFormatKind.Number, '0.0000000000'),
        //same hack for percents
        '00000000-0000-0000-0000-de4db33f1201': new ValueFormat('00000000-0000-0000-0000-de4db33f1201', MeshCellValueFormatKind.Percent, '0%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1202': new ValueFormat('00000000-0000-0000-0000-de4db33f1202', MeshCellValueFormatKind.Percent, '0.0%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1203': new ValueFormat('00000000-0000-0000-0000-de4db33f1203', MeshCellValueFormatKind.Percent, '0.000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1204': new ValueFormat('00000000-0000-0000-0000-de4db33f1204', MeshCellValueFormatKind.Percent, '0.0000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1205': new ValueFormat('00000000-0000-0000-0000-de4db33f1205', MeshCellValueFormatKind.Percent, '0.00000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1206': new ValueFormat('00000000-0000-0000-0000-de4db33f1206', MeshCellValueFormatKind.Percent, '0.000000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1207': new ValueFormat('00000000-0000-0000-0000-de4db33f1207', MeshCellValueFormatKind.Percent, '0.0000000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1208': new ValueFormat('00000000-0000-0000-0000-de4db33f1208', MeshCellValueFormatKind.Percent, '0.00000000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1209': new ValueFormat('00000000-0000-0000-0000-de4db33f1209', MeshCellValueFormatKind.Percent, '0.000000000%', percentFormatChecker, percentValueExtractor),
        '00000000-0000-0000-0000-de4db33f1210': new ValueFormat('00000000-0000-0000-0000-de4db33f1210', MeshCellValueFormatKind.Percent, '0.0000000000%', percentFormatChecker, percentValueExtractor),
        //hack for currencies
        '00000000-0000-0000-0000-de4db33f8001': new ValueFormat('00000000-0000-0000-0000-de4db33f8001', MeshCellValueFormatKind.Currency, '"$"#,##0;-$#,##0', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8002': new ValueFormat('00000000-0000-0000-0000-de4db33f8002', MeshCellValueFormatKind.Currency, '"$"#,##0.0;-$#,##0.0', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8000': MeshCellValueFormat.Currency,
        '00000000-0000-0000-0000-de4db33f8003': new ValueFormat('00000000-0000-0000-0000-de4db33f8003', MeshCellValueFormatKind.Currency, '"$"#,##0.000;-$#,##0.000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8004': new ValueFormat('00000000-0000-0000-0000-de4db33f8004', MeshCellValueFormatKind.Currency, '"$"#,##0.0000;-$#,##0.0000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8005': new ValueFormat('00000000-0000-0000-0000-de4db33f8005', MeshCellValueFormatKind.Currency, '"$"#,##0.00000;-$#,##0.00000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8006': new ValueFormat('00000000-0000-0000-0000-de4db33f8006', MeshCellValueFormatKind.Currency, '"$"#,##0.000000;-$#,##0.000000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8007': new ValueFormat('00000000-0000-0000-0000-de4db33f8007', MeshCellValueFormatKind.Currency, '"$"#,##0.0000000;-$#,##0.0000000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8008': new ValueFormat('00000000-0000-0000-0000-de4db33f8008', MeshCellValueFormatKind.Currency, '"$"#,##0.00000000;-$#,##0.00000000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8009': new ValueFormat('00000000-0000-0000-0000-de4db33f8009', MeshCellValueFormatKind.Currency, '"$"#,##0.000000000;-$#,##0.000000000', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f8010': new ValueFormat('00000000-0000-0000-0000-de4db33f8010', MeshCellValueFormatKind.Currency, '"$"#,##0.0000000000;-$#,##0.0000000000', currencyFormatChecker, currencyValueExtractor),
        //hack for financial
        '00000000-0000-0000-0000-de4db33f3100': MeshCellValueFormat.Financial,
        '00000000-0000-0000-0000-de4db33f3101': new ValueFormat('00000000-0000-0000-0000-de4db33f3101', MeshCellValueFormatKind.Financial, '_(* #,##0.0_);_(* (#,##0.0);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3102': new ValueFormat('00000000-0000-0000-0000-de4db33f3102', MeshCellValueFormatKind.Financial, '_(* #,##0.00_);_(* (#,##0.00);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3103': new ValueFormat('00000000-0000-0000-0000-de4db33f3103', MeshCellValueFormatKind.Financial, '_(* #,##0.000_);_(* (#,##0.000);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3104': new ValueFormat('00000000-0000-0000-0000-de4db33f3104', MeshCellValueFormatKind.Financial, '_(* #,##0.0000_);_(* (#,##0.0000);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3105': new ValueFormat('00000000-0000-0000-0000-de4db33f3105', MeshCellValueFormatKind.Financial, '_(* #,##0.00000_);_(* (#,##0.00000);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3106': new ValueFormat('00000000-0000-0000-0000-de4db33f3106', MeshCellValueFormatKind.Financial, '_(* #,##0.000000_);_(* (#,##0.000000);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3107': new ValueFormat('00000000-0000-0000-0000-de4db33f3107', MeshCellValueFormatKind.Financial, '_(* #,##0.0000000_);_(* (#,##0.0000000);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3108': new ValueFormat('00000000-0000-0000-0000-de4db33f3108', MeshCellValueFormatKind.Financial, '_(* #,##0.00000000_);_(* (#,##0.00000000);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3109': new ValueFormat('00000000-0000-0000-0000-de4db33f3109', MeshCellValueFormatKind.Financial, '_(* #,##0.000000000_);_(* (#,##0.000000000_);_(* "-"_);_(@_)'),
        '00000000-0000-0000-0000-de4db33f3110': new ValueFormat('00000000-0000-0000-0000-de4db33f3110', MeshCellValueFormatKind.Financial, '_(* #,##0.0000000000_);_(* (#,##0.0000000000_);_(* "-"_);_(@_)'),
        //hack for accounting
        '00000000-0000-0000-0000-de4db33f6001': new ValueFormat('00000000-0000-0000-0000-de4db33f6001', MeshCellValueFormatKind.Accounting, '"$"#,##0_);$(#,##0);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6002': new ValueFormat('00000000-0000-0000-0000-de4db33f6002', MeshCellValueFormatKind.Accounting, '"$"#,##0.0_);$(#,##0.0);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6000': MeshCellValueFormat.Accounting,
        '00000000-0000-0000-0000-de4db33f6003': new ValueFormat('00000000-0000-0000-0000-de4db33f6003', MeshCellValueFormatKind.Accounting, '"$"#,##0.000_);$_(#,##0.000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6004': new ValueFormat('00000000-0000-0000-0000-de4db33f6004', MeshCellValueFormatKind.Accounting, '"$"#,##0.0000_);$(#,##0.0000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6005': new ValueFormat('00000000-0000-0000-0000-de4db33f6005', MeshCellValueFormatKind.Accounting, '"$"#,##0.00000_);$(#,##0.00000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6006': new ValueFormat('00000000-0000-0000-0000-de4db33f6006', MeshCellValueFormatKind.Accounting, '"$"#,##0.000000_);$(#,##0.000000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6007': new ValueFormat('00000000-0000-0000-0000-de4db33f6007', MeshCellValueFormatKind.Accounting, '"$"#,##0.0000000_);$(#,##0.0000000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6008': new ValueFormat('00000000-0000-0000-0000-de4db33f6008', MeshCellValueFormatKind.Accounting, '"$"#,##0.00000000_);$(#,##0.00000000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6009': new ValueFormat('00000000-0000-0000-0000-de4db33f6009', MeshCellValueFormatKind.Accounting, '"$"#,##0.000000000_);$(#,##0.000000000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),
        '00000000-0000-0000-0000-de4db33f6010': new ValueFormat('00000000-0000-0000-0000-de4db33f6010', MeshCellValueFormatKind.Accounting, '"$"#,##0.0000000000_);$(#,##0.0000000000);_(* "-"_)', currencyFormatChecker, currencyValueExtractor),

        //Number formats to use when user press 0<- and ->0.00 (increase or decrease decimal points)
        numberFormats: [
            '00000000-0000-0000-0000-de4db33f2000', //0
            '00000000-0000-0000-0000-de4db33f2001', //0.0
            '00000000-0000-0000-0000-de4db33f2002', //0.00
            '00000000-0000-0000-0000-de4db33f2003', //and so on
            '00000000-0000-0000-0000-de4db33f2004',
            '00000000-0000-0000-0000-de4db33f2005',
            '00000000-0000-0000-0000-de4db33f2006',
            '00000000-0000-0000-0000-de4db33f2007',
            '00000000-0000-0000-0000-de4db33f2008',
            '00000000-0000-0000-0000-de4db33f2009',
            '00000000-0000-0000-0000-de4db33f2010'
        ],

        //Percent formats to use when user press 0<- and ->0.00 (increase or decrease decimal points)
        percentFormats: [
            '00000000-0000-0000-0000-de4db33f1201', //0%
            '00000000-0000-0000-0000-de4db33f1202', //0.0%
            '00000000-0000-0000-0000-de4db33f1200', //0.00% - percent format we use by default!!!
            '00000000-0000-0000-0000-de4db33f1203', //and so on
            '00000000-0000-0000-0000-de4db33f1204',
            '00000000-0000-0000-0000-de4db33f1205',
            '00000000-0000-0000-0000-de4db33f1206',
            '00000000-0000-0000-0000-de4db33f1207',
            '00000000-0000-0000-0000-de4db33f1208',
            '00000000-0000-0000-0000-de4db33f1209',
            '00000000-0000-0000-0000-de4db33f1210'
        ],

        //Currency formats to use when user press 0<- and ->0.00 (increase or decrease decimal points)
        currencyFormats: [
            '00000000-0000-0000-0000-de4db33f8001', //$1,000
            '00000000-0000-0000-0000-de4db33f8002', //$1,000.0
            '00000000-0000-0000-0000-de4db33f8000', //$1,000.00 - Default one
            '00000000-0000-0000-0000-de4db33f8003', //and so on
            '00000000-0000-0000-0000-de4db33f8004',
            '00000000-0000-0000-0000-de4db33f8005',
            '00000000-0000-0000-0000-de4db33f8006',
            '00000000-0000-0000-0000-de4db33f8007',
            '00000000-0000-0000-0000-de4db33f8008',
            '00000000-0000-0000-0000-de4db33f8009',
            '00000000-0000-0000-0000-de4db33f8010'
        ],

        //Financial formats to use when user press 0<- and ->0.00 (increase or decrease decimal points)
        financialFormats: [
            '00000000-0000-0000-0000-de4db33f3100', //1,000
            '00000000-0000-0000-0000-de4db33f3101', //1,000.0
            '00000000-0000-0000-0000-de4db33f3102', //1,000.00
            '00000000-0000-0000-0000-de4db33f3103', //and so on
            '00000000-0000-0000-0000-de4db33f3104',
            '00000000-0000-0000-0000-de4db33f3105',
            '00000000-0000-0000-0000-de4db33f3106',
            '00000000-0000-0000-0000-de4db33f3107',
            '00000000-0000-0000-0000-de4db33f3108',
            '00000000-0000-0000-0000-de4db33f3109',
            '00000000-0000-0000-0000-de4db33f3110'
        ],

        //Accounting formats to use when user press 0<- and ->0.00 (increase or decrease decimal points)
        accountingFormats: [
            '00000000-0000-0000-0000-de4db33f6001', //$ 1,000
            '00000000-0000-0000-0000-de4db33f6002', //$ 1,000.0
            '00000000-0000-0000-0000-de4db33f6000', //$ 1,000.00
            '00000000-0000-0000-0000-de4db33f6003', //and so on
            '00000000-0000-0000-0000-de4db33f6004',
            '00000000-0000-0000-0000-de4db33f6005',
            '00000000-0000-0000-0000-de4db33f6006',
            '00000000-0000-0000-0000-de4db33f6007',
            '00000000-0000-0000-0000-de4db33f6008',
            '00000000-0000-0000-0000-de4db33f6009',
            '00000000-0000-0000-0000-de4db33f6010'
        ],

        //Formats to use to guess format of input string
        formatsToProbe: [MeshCellValueFormat.Percent, MeshCellValueFormat.Currency, MeshCellValueFormat.DateTime,
            MeshCellValueFormat.Date, MeshCellValueFormat.Time, MeshCellValueFormat.Number]
    };

    private static _countDecimals(value:number)
    {
        if( Math.floor(value) !== value )
            return value.toString().split('.')[1].length || 0;
        return 0;
    }

    public static getFormatDependingOnDigitsAfterPointInValue(value:IValue,
                                                              format:IMeshCellValueFormat):IMeshCellValueFormat
    {
        const extractedValue = format.extractValue(value.toString());
        if( !Type.isInstanceOf(extractedValue, Type.Number) ) return MeshCellValueFormat.General;
        let val = (extractedValue as ANumber).value;
        if( format.kind == MeshCellValueFormatKind.Percent )
        {
            val = val * 100;
        }
        let decimals = MeshCellValueFormat._countDecimals(val);
        let position = decimals <= 10 ? decimals : 10;
        let newFormatId;
        if( format.kind == MeshCellValueFormatKind.Number )
        {
            newFormatId = MeshCellValueFormat.BuiltInFormats.numberFormats[position];
        }
        else if( format.kind == MeshCellValueFormatKind.Percent )
        {
            newFormatId = MeshCellValueFormat.BuiltInFormats.percentFormats[position];

        }
        else if( format.kind == MeshCellValueFormatKind.Currency )
        {
            newFormatId = MeshCellValueFormat.BuiltInFormats.currencyFormats[position];

        }
        else if( format.kind == MeshCellValueFormatKind.Financial )
        {
            newFormatId = MeshCellValueFormat.BuiltInFormats.financialFormats[position];

        }
        else if( format.kind == MeshCellValueFormatKind.Accounting )
        {
            newFormatId = MeshCellValueFormat.BuiltInFormats.accountingFormats[position];

        }
        else
        {
            newFormatId = format.id;
        }
        return MeshCellValueFormat.BuiltInFormats[newFormatId];
    }
}
